<template>
  <Row :gutter="20">
    <Col :span="14">
      <div class="content-top">
        <div v-if="helpPlanDetail.content" v-html="helpPlanDetail.content" style="margin-top: 20px"></div>
        <img v-if="helpPlanDetail.cover" class="success-img" :src="helpPlanDetail.cover" style="width: 100%; margin-top: 20px" />
        <a v-if="helpPlanDetail.url" :href="helpPlanDetail.url" target="_blank" style="display: block; margin-top: 20px">查看原文</a>
      </div>
    </Col>
    <Col :span="10" class="box">
      <h3 style="padding: 20px">申请参与帮扶计划</h3>
      <div
        class="content"
        v-show="
          !helpPlanDetail.help_company ||
          (helpPlanDetail.help_company && (helpPlanDetail.help_company.status === -1 || helpPlanDetail.help_company.status === 2))
        "
      >
        <div style="padding: 20px">
          <p>说明：</p>
          <p>1、确认企业信息完善</p>
          <p>2、联系您所在工会确认需要上传的申请资料</p>
          <Upload
            ref="upload"
            :headers="$uploader.headers()"
            :action="$uploader.action"
            :on-format-error="handleFormatError"
            :format="['doc', 'docx', 'pdf', 'jpg', 'xlsx', 'xls']"
            multiple
            :on-exceeded-size="handleMaxSize"
            :max-size="2048"
            :before-upload="handleBeforeUpload"
            :default-file-list="defaultList"
          >
            <Button icon="ios-cloud-upload-outline" style="margin: 20px 0 10px">上传文件</Button>
          </Upload>
          <!-- :default-file-list="uploadList" -->

          <p>支持扩展名：.doc&ensp;.docx&ensp;.pdf&ensp;.jpg&ensp;.xls&ensp;.xlsx</p>
          <p>最多支持上传10个附件，单个附件大小不超过2MB</p>
        </div>
        <div class="footer">
          <Button type="primary" @click="submit" v-if="!helpPlanDetail.help_company">申请</Button>
          <Button type="primary" @click="submit_" v-else>申请</Button>
        </div>
      </div>

      <div
        class="content"
        v-if="helpPlanDetail.help_company && (helpPlanDetail.help_company.status === 0 || helpPlanDetail.help_company.status === 1)"
      >
        <div class="center" v-if="helpPlanDetail.help_company">
          <i v-if="helpPlanDetail.help_company.status === 0" class="ivu-icon ivu-icon-ios-alert-outline" style="color: #ff9900"></i>
          <i v-if="helpPlanDetail.help_company.status === 1" class="ivu-icon ivu-icon-ios-checkmark-circle" style="color: #19be6b"></i>
          <h3 style="margin: 20px 0">
            {{ helpPlanDetail.help_company.status === 0 ? '审核中' : helpPlanDetail.help_company.status === 1 ? '已加入帮扶计划' : '' }}
          </h3>
          <p>
            {{
              helpPlanDetail.help_company.status === 0
                ? '审核通过后，将通过短信告知'
                : helpPlanDetail.help_company.status === 1
                ? '可以在帮扶项目页面，创建帮扶项目'
                : ''
            }}
          </p>
          <Button v-if="helpPlanDetail.help_company.status === 1" type="primary" style="margin-top: 40px" @click="toProject">
            进入帮扶项目
          </Button>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  props: {
    helpPlanDetail: {
      type: Object,
      default: {}
    }
  },
  name: 'HelpPlan',
  components: {},
  data() {
    return {
      readOnly: true,
      menuCurrentName: '1',
      menuList: [
        {
          label: '就业帮扶',
          name: '1'
        }
      ],
      status: 'apply' || 'success' || 'review',
      uploadList: [],
      defaultList: []
    };
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList || [];
  },
  methods: {
    setUpload() {
      this.uploadList = this.$refs.upload.fileList || [];
    },
    submit() {
      let uploadList = [];
      this.uploadList.map(item => {
        if (item.response && item.response.data && item.response.data.url) {
          uploadList.push({ name: item.name, url: item.response.data.url });
        }
      });
      this.$axios
        .request({
          url: 'front/v1/company/help-company',
          method: 'post',
          data: {
            planId: this.helpPlanDetail.id,
            files: uploadList
          }
        })
        .then(res => {
          this.$Notice.success({
            title: '提交成功'
          });
          this.$emit('helpPlanDetail', '1');
        });
    },
    submit_() {
      let uploadList = [];
      this.uploadList.map(item => {
        if (item.response && item.response.data && item.response.data.url) {
          uploadList.push({ name: item.name, url: item.response.data.url });
        }
      });
      this.$axios
        .request({
          url: 'front/v1/company/help-company/' + this.helpPlanDetail.help_company.id,
          method: 'put',
          data: {
            planId: parseInt(this.menuCurrentName),
            files: uploadList
          }
        })
        .then(res => {
          this.$Notice.success({
            title: '提交成功'
          });
          this.$emit('helpPlanDetail', '1');
        });
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不对',
        desc: '需上传doc, docx, pdf, jpg, xlx, xlsx格式文件'
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 10;
      if (!check) {
        this.$Notice.warning({
          title: '最多上传10个附件'
        });
      }
      return check;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '提示',
        desc: '文件大小超过 2MB'
      });
    },
    toProject() {
      this.$emit('changeSubMenu', '1');
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  border: 1px solid #dcdee2;
  padding-bottom: 50px;

  .content {
    border-top: 1px solid #dcdee2;
    height: 100%;
  }

  .footer {
    width: 100%;
    padding: 10px 20px;
    text-align: right;
    border-top: 1px solid #dcdee2;
    position: absolute;
    bottom: 0;
  }

  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.ivu-icon {
  font-size: 100px;
  margin-top: 20px;
}
.content-top {
  height: 540px;
  overflow-y: scroll;
}
</style>
